import { Component, OnInit } from '@angular/core';
import { HeaderService, UserService, UtilsService } from '../../_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
declare const $ : any;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})

export class ForgotpasswordComponent implements OnInit {
  public forgotPasswordForm: FormGroup;
  public submitted : boolean;
  public success : boolean;

  constructor(
    private header: HeaderService,
    private formBuilder: FormBuilder,
    private users : UserService,
    private utils : UtilsService,
    private toastr : ToastrService,
    private translate : TranslateService
  ) { 
    this.header.setHeader(false,false,true,true);
  }

  get f() { 
    return this.forgotPasswordForm.controls; 
  }

  ngOnInit() {  
    
    this.submitted = false;
    this.success = false;

    this.forgotPasswordForm = this.formBuilder.group({
      // email: ['', [Validators.required, Validators.email]],
      username: ['', Validators.required],
      acceptRGPD: ['', Validators.requiredTrue]
    });

  }

  onRGPD(){
    $('#modal-registre-rgpd').modal('show');
    return false;
  }


  onSubmit (){
    this.submitted = true;

    if (this.forgotPasswordForm.invalid) {
      this.header.scrollTop();
      return;
    }

    this.users.requestPasswordRecovery(this.f.username.value).subscribe(
      result => {
        this.success = true;
        this.header.scrollTop()
      },
      error => {
        this.success = false;
      }
    );
  }

}
